import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const LegalLayout = ({ eyebrow, title, updated, children }) => {
  const { content } = useContent();
  const COMPANY = content.company;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-paper">
      <header className="bg-navy-deep text-paper grain relative">
        <div className="max-w-3xl mx-auto px-6 md:px-8 py-10 relative z-10">
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-paper/60 hover:text-gold transition-colors text-xs uppercase tracking-[0.2em]">
            <ArrowLeft size={15} /> Torna al sito
          </Link>
          <img src={COMPANY.logo} alt="Cancella Infissi" className="h-16 w-auto object-contain bg-paper/95 p-2 mt-10 block" />
          <p className="eyebrow mt-8">{eyebrow}</p>
          <h1 className="font-serif font-light text-4xl md:text-5xl mt-2">{title}</h1>
          {updated && <p className="text-paper/40 text-xs mt-4">Ultimo aggiornamento: {updated}</p>}
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-8 py-14 legal-content text-navy/80 leading-relaxed">
        {children}
      </main>

      <footer className="border-t border-gold/20 py-8">
        <div className="max-w-3xl mx-auto px-6 md:px-8 flex flex-col sm:flex-row justify-between gap-3 text-[0.7rem] uppercase tracking-[0.15em] text-navy/40">
          <span>© {new Date().getFullYear()} {COMPANY.name} — P. IVA {COMPANY.piva}</span>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-gold transition-colors">Privacy</Link>
            <Link to="/cookie" className="hover:text-gold transition-colors">Cookie</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const Section = ({ n, title, children }) => (
  <section className="mb-9">
    <h2 className="font-serif text-2xl text-navy mb-3">{n ? `${n}. ` : ""}{title}</h2>
    <div className="space-y-3 text-[0.95rem]">{children}</div>
  </section>
);
